export enum ActionID {
  NEW_PORTFOLIO = "new-portfolio-action",
  ADD_SECURITY = "add-security-action",
  EXCEL_EXPORT = "export-excel-action",
  CSV_DOWNLOAD = "csv-download-action",
  CSV_UPLOAD = "csv-upload-action",
  DELETE_SECURITIES = "delete-securities-action",
  CONFIGURATION = "change-configuration-action",
}
